// extracted by mini-css-extract-plugin
export default {"product-form-select":"ProductFormSelect_product-form-select__2XCu7","label":"ProductFormSelect_label__1hdHp","highlighted":"ProductFormSelect_highlighted__QTlAD"};